<template>  
<div style="width:100%;height:100%" v-loading="loading" >
</div>
 
</template>

<script setup>

import {onMounted,nextTick,ref} from 'vue'
import { useRoute ,useRouter} from 'vue-router';
import { noLogin } from '@/utils/nologin';
import CryptoJS from 'crypto-js';

const route = useRoute ();
const router = useRouter()
const loading = ref(true)
onMounted(()=>{


 
 const success = noLogin(route.params.user,route.params.password,nextTick,router)
 if(success == 'success'){
    loading.value = false
 }
})

</script>
<style lang="scss">



</style>